import { AlertConfig } from '../models';
import { inject } from '@angular/core';
import { EnvConfigService, LuigiCoreService } from '@openmfp/portal-ui-lib';

const ALERT_PREFIX = 'dxp.alert.';
const TEST_TENANT_ID = '01ezesr3cgghmhgpbny04hv8qn';

export async function alertInitializer() {
  const luigiCoreService = inject(LuigiCoreService);
  const envConfigService = inject(EnvConfigService);
  const env = await envConfigService.getEnvConfig();
  const alertConfigs = env.alertConfigs as AlertConfig[];

  const luigiCoreServiceReadyInterval = setInterval(() => {
    if (
      'showAlert' in luigiCoreService &&
      // @ts-expect-error for optional chaining
      typeof globalThis.Luigi?.showAlert === 'function' &&
      luigiCoreService.getGlobalContext().tenantid
    ) {
      clearInterval(luigiCoreServiceReadyInterval);

      if (luigiCoreService.getGlobalContext().tenantid === TEST_TENANT_ID) {
        return;
      }

      const now = new Date();
      const enabledAlerts = alertConfigs.filter(
        (alertConfig) =>
          localStorage.getItem(`${ALERT_PREFIX}${alertConfig.id}`) !== 'true' &&
          now >= new Date(alertConfig.startDate) &&
          now <= new Date(alertConfig.endDate),
      );

      for (const alertConfig of enabledAlerts) {
        showAlert(luigiCoreService, alertConfig);
      }
    }
  }, 1000);
}

function showAlert(
  luigiCoreService: LuigiCoreService,
  alertConfig: AlertConfig,
) {
  const links: Record<
    string,
    { text: string; dismissKey: string; externalUrl: string }
  > = {};
  for (let i = 0; i < alertConfig.links.length; i++) {
    links[`LINK_${i + 1}`] = {
      text: alertConfig.links[i].text,
      dismissKey: `LINK_${i + 1}`,
      externalUrl: alertConfig.links[i].url,
    };
  }
  luigiCoreService
    .showAlert({
      text: alertConfig.text,
      type: alertConfig.type,
      links,
    })
    .then((value: string) => {
      const link = links[value];
      if (link) {
        window.open(decodeURI(link.externalUrl), '_blank');
        showAlert(luigiCoreService, alertConfig);
      } else {
        localStorage.setItem(`${ALERT_PREFIX}${alertConfig.id}`, 'true');
      }
    });
}
